import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";

const labelStyle = {
  fontSize: "14px",
  fontWeight: 600,
  color: "var(--primary-25)",
  marginBottom: "2px",
  display: "block",
};

const inputClass = "form-control height-25 p-0 p-l-5 rounded-0";
const inputStyle = { color: "black" };

const ResetPasswordModal = ({ show, handleClose, handleSave }) => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const reset = () => {
    setNewPassword("");
    setConfirmPassword("");
    setShowNew(false);
    setShowConfirm(false);
  };

  const onClose = () => {
    if (loading) return;
    reset();
    handleClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    if (!newPassword.trim()) {
      toast.error("Password cannot be empty.");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match.");
      return;
    }
    setLoading(true);
    try {
      await handleSave(newPassword);
      reset();
      handleClose();
    } catch (err) {
      const data = err.response?.data;
      const message =
        data?.error ||
        data?.detail ||
        data?.password ||
        data?.non_field_errors ||
        (typeof data === "string" ? data : err.message);
      toast.error(
        Array.isArray(message)
          ? message.join(" ")
          : typeof message === "string"
            ? message
            : "Unable to reset the password. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      dialogClassName="max-500 modal-dialog-centered"
      contentClassName="custom-modal-new-provider"
      show={show}
      onHide={loading ? undefined : onClose}
      aria-labelledby="reset-user-password-title"
    >
      <form onSubmit={handleSubmit} noValidate>
        <Modal.Header
          style={{ borderBottom: "0px" }}
          className="text-center height-25 p-0 bg-primary popup-heading-color justify-content-center"
        >
          <Modal.Title
            id="reset-user-password-title"
            className="mx-auto height-25 font-weight-semibold text-uppercase popup-heading-color d-flex align-items-center"
            style={{ fontSize: "14px", fontWeight: "600" }}
          >
            Reset User Password
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "5px" }}>
          {/* New Password */}
          <div className="row mx-0 align-items-center custom-margin-bottom">
            <div className="flex-g-1 p-0">
              <label htmlFor="resetNewPassword" style={labelStyle}>
                New Password
              </label>
              <div className="position-relative">
                <input
                  id="resetNewPassword"
                  name="password"
                  autoComplete="new-password"
                  disabled={loading}
                  type={showNew ? "text" : "password"}
                  className={inputClass}
                  style={inputStyle}
                  placeholder="Enter new password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="position-absolute border-0 bg-transparent p-0"
                  style={{ top: "0px", right: "10px" }}
                  aria-label={showNew ? "Hide new password" : "Show new password"}
                  disabled={loading}
                  onClick={() => setShowNew((prev) => !prev)}
                >
                  {showNew ? (
                    <FaEyeSlash size={14} aria-hidden="true" />
                  ) : (
                    <FaEye size={14} aria-hidden="true" />
                  )}
                </button>
              </div>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="row mx-0 align-items-center custom-margin-bottom">
            <div className="flex-g-1 p-0">
              <label htmlFor="resetConfirmPassword" style={labelStyle}>
                Confirm Password
              </label>
              <div className="position-relative">
                <input
                  id="resetConfirmPassword"
                  name="confirm_password"
                  autoComplete="new-password"
                  disabled={loading}
                  type={showConfirm ? "text" : "password"}
                  className={inputClass}
                  style={inputStyle}
                  placeholder="Confirm new password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="position-absolute border-0 bg-transparent p-0"
                  style={{ top: "0px", right: "10px" }}
                  aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
                  disabled={loading}
                  onClick={() => setShowConfirm((prev) => !prev)}
                >
                  {showConfirm ? (
                    <FaEyeSlash size={14} aria-hidden="true" />
                  ) : (
                    <FaEye size={14} aria-hidden="true" />
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer
          className="p-0 mt-0 padding-outside-btn-new-provider"
          style={{ borderTop: "none" }}
        >
          <Button
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            type="button"
            variant="secondary"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            className="button-padding-footer-new-provider d-flex align-items-center justify-content-center"
            type="submit"
            disabled={loading}
          >
            {loading ? "Resetting…" : "Reset Password"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default ResetPasswordModal;
